export const ZPL_FONTS = {
  'ZPL Default': {
    designator: '0',
    description: 'Scalable CG Triumvirate',
    displayFont: "Arial, 'Helvetica Neue', Helvetica, sans-serif",
  },
  'Zebra Font A': {
    designator: 'A',
    description: 'Compact bitmap font',
    displayFont: "'Arial Narrow', Arial, sans-serif",
  },
  'Zebra Font B': {
    designator: 'B',
    description: 'Compact bitmap font',
    displayFont: "'Courier New', Courier, monospace",
  },
  'Zebra Font C': {
    designator: 'C',
    description: 'Bitmap font',
    displayFont: "'Arial Narrow', Arial, sans-serif",
  },
  'Zebra Font D': {
    designator: 'D',
    description: 'Bitmap font',
    displayFont: "Arial, 'Helvetica Neue', Helvetica, sans-serif",
  },
  'Zebra Font E': {
    designator: 'E',
    description: 'OCR-B bitmap font',
    displayFont: "'Courier New', Courier, monospace",
  },
  'Zebra Font F': {
    designator: 'F',
    description: 'Large bitmap font',
    displayFont: "Arial, 'Helvetica Neue', Helvetica, sans-serif",
  },
  'Zebra Font G': {
    designator: 'G',
    description: 'Large bitmap font',
    displayFont: "Arial Black, Arial, sans-serif",
  },
  'Zebra Font H': {
    designator: 'H',
    description: 'OCR-A bitmap font',
    displayFont: "'Courier New', Courier, monospace",
  },
} as const;

export type ZplFontFamily = keyof typeof ZPL_FONTS;

export const ZPL_FONT_OPTIONS: { label: string; value: ZplFontFamily }[] = Object.entries(
  ZPL_FONTS,
).map(([value, font]) => ({
  label: `${value} (${font.description})`,
  value: value as ZplFontFamily,
}));

function isZplFontFamily(fontFamily?: string): fontFamily is ZplFontFamily {
  return !!fontFamily && Object.prototype.hasOwnProperty.call(ZPL_FONTS, fontFamily);
}

export function resolveZplFont(fontFamily?: string) {
  return isZplFontFamily(fontFamily) ? ZPL_FONTS[fontFamily] : ZPL_FONTS['ZPL Default'];
}

export function resolveZplFontFamily(fontFamily?: string): ZplFontFamily {
  return isZplFontFamily(fontFamily) ? fontFamily : 'ZPL Default';
}

export function getZplDisplayFont(fontFamily?: string): string {
  return resolveZplFont(fontFamily).displayFont;
}

export function getZplFontCommand(
  fontFamily: string | undefined,
  fontSize: number,
  scaleX: number = 1,
  orientation: 'N' | 'R' | 'I' | 'B' = 'N',
  scaleY: number = 1,
): string {
  const font = resolveZplFont(fontFamily);
  const height = Math.round(fontSize * scaleY);
  const width = Math.round(fontSize * scaleX);
  return `^A${font.designator}${orientation},${height},${width}`;
}
